import { type Page } from "@inertiajs/core";
import { createContext } from "solid-js";

const PageContext = createContext<Page>();

export default PageContext;
